export default Object.freeze({
  MOBILE: '$MOB',
  HOME: '$HM'
})
